import React from 'react';

function WebpImage({
	className = '',
	backupImage,
	backupFormat,
	webpImage,
	imageFit = 'unset',
	imagePosition = 'unset',
	width = 'auto',
	style = {},
	alt,
}) {
	return (
		<picture>
			<source srcSet={webpImage} type='image/webp' />
			<source srcSet={backupImage} type={`image/${backupFormat}`} />
			<img
				width={width}
				className={className}
				src={backupImage}
				style={{ objectFit: imageFit, objectPosition: imagePosition, ...style }}
				alt={alt}
			/>
		</picture>
	);
}

export default WebpImage;
